<title>{{ ndcFeaturesSupportInNdcFaqPage.htmlTitle }}</title>
<app-banner [banner]="ndcFeaturesSupportInNdcFaqPage.banner"></app-banner>
<div class="container faq-disruption-notifications">
  <a [href]="BackLinkURL"><i [ngClass]="BackLinkIcon"></i>{{ BackLinkTitle }}</a>
  <app-border-section [param]="param" [sections]="ndcFeaturesSupportInNdcFaqPage.sections"></app-border-section>
</div>
